const viewAny = (permissions) => {
  return permissions.includes('read-counties')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-counties')
}

const update = (permissions) => {
  return hasPermission(permissions, 'update-counties')
}

const deletee = (permissions) => {
  return hasPermission(permissions, 'delete-counties')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};